import { t } from "i18next";
import { useMemo, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

function DeviceConfig({ dataL, dataR, handleChange }) {
    const displayData = useMemo(() => {
        return dataL || dataR;
    }, [dataL, dataR]);

    const [dryingOn, setDryingOn] = useState(displayData?.configuration?.dryingTimeSec > 0);
    const [dryingTimeMin, setDryingTimeMin] = useState(displayData?.configuration?.dryingTimeSec / 60);
    const [logOn, setLogOn] = useState(displayData?.configuration?.logOn);
    const [constPwm, setConstPwm] = useState(displayData?.configuration?.constPwm);
    const [cooldown, setCooldown] = useState(displayData?.configuration?.cooldown);
    const [testMode, setTestMode] = useState(displayData?.configuration?.testMode);

    function processChange() {
        const newConfiguration = {
            logOn: logOn,
            constPwm: constPwm,
            cooldown: cooldown,
            testMode: testMode,
            dryingTimeSec: dryingOn ? Math.round(dryingTimeMin * 60) : 0
        };
        handleChange(newConfiguration);
    }

    return (
        <Container className="my-4">
            <Row>
                <Col lg={6} className="me-auto">
                    <Form>
                        <Form.Group className="mb-3" controlId="dryingOn">
                            <Form.Check
                                type="switch"
                                id="dryingOn"
                                label={t("device.config.dryingOn")}
                                checked={dryingOn}
                                onChange={() => setDryingOn(!dryingOn)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="dryingTimeMin">
                            <Form.Label>{t("device.config.dryingTime")}</Form.Label>
                            <Form.Range
                                min={0}
                                max={720}
                                step={30}
                                value={dryingTimeMin}
                                onChange={(event) => setDryingTimeMin(event.target.value)}
                            />
                            <Form.Text>{t("device.config.dryingTimeMin", { dryingTimeMin: dryingTimeMin })}</Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="constPwm">
                            <Form.Check
                                type="switch"
                                id="constPwm"
                                label={t("device.config.constPwm")}
                                checked={constPwm}
                                onChange={() => setConstPwm(!constPwm)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="cooldown">
                            <Form.Check
                                type="switch"
                                id="cooldown"
                                label={t("device.config.cooldown")}
                                checked={cooldown}
                                onChange={() => setCooldown(!cooldown)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="logOn">
                            <Form.Check
                                type="switch"
                                id="logOn"
                                label={t("device.config.logOn")}
                                checked={logOn}
                                onChange={() => setLogOn(!logOn)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="testMode">
                            <Form.Check
                                type="switch"
                                id="testMode"
                                label={t("device.config.testMode")}
                                checked={testMode}
                                onChange={() => setTestMode(!testMode)}
                            />
                        </Form.Group>

                        <div className="text-center">
                            <Button variant="primary" onClick={processChange}>
                                {t("device.config.save")}
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
};

export default DeviceConfig;
